export default "__VITE_ASSET__2989e7d1__"